var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-box"},[_c('div',{staticClass:"nav-box-header"},[_vm._v("\n    My Settings\n  ")]),_c('router-link',{class:{ 'nav-item mt-1' : true, 'selected' : _vm.$route.name == 'broker-account' },attrs:{"to":{
      name: 'broker-account',
      params : {
        brokerId : _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("My Details")]),_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'broker-password' },attrs:{"to":{
      name  : 'broker-password',
      params: {
        brokerId : _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("Password")]),_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'broker-multi-factor-auth' },attrs:{"to":{
      name  : 'broker-multi-factor-auth',
      params: {
        brokerId : _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("Multi-factor Authentication")]),_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'broker-site-appearance' },attrs:{"to":{
      name  : 'broker-site-appearance',
      params: {
        brokerId : _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("Site Appearance")]),_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'broker-integration' },attrs:{"to":{
      name  : 'broker-integration',
      params: {
        brokerId : _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("Integrations")]),_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'broker-mail-setting' },attrs:{"to":{
      name: 'broker-mail-setting',
      params: {
        brokerId: _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("Mail Settings")]),(_vm.$store.state[_vm.$store.state.view + 'Module'].broker.user_id == _vm.$store.state.user.id)?[_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'broker-payment' },attrs:{"to":{
        name  : 'broker-payment',
        params: {
          brokerId : _vm.$route.params.brokerId
        }
      },"tag":"a"}},[_vm._v("Payment Details")])]:_vm._e(),_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'broker-lead-capture' },attrs:{"to":{
      name  : 'broker-lead-capture',
      params: {
        brokerId : _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("Lead Capture Form")]),(!_vm.$store.state[_vm.$store.state.view + 'Module'].broker.suspended)?_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'broker-template' },attrs:{"to":{
      name  : 'broker-template',
      params: {
        brokerId : _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("Templates")]):_vm._e(),(!_vm.$store.state[_vm.$store.state.view + 'Module'].broker.suspended)?_c('router-link',{class:{ 'nav-item' : true, 'selected' : _vm.$route.name == 'broker-notifications' },attrs:{"to":{
      name  : 'broker-notifications',
      params: {
        brokerId : _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("Notifications")]):_vm._e(),(!_vm.$store.state[_vm.$store.state.view + 'Module'].broker.suspended)?_c('router-link',{class:{ 'nav-item mb-1' : true, 'selected' : _vm.$route.name == 'broker-client-sources' },attrs:{"to":{
      name  : 'broker-client-sources',
      params: {
        brokerId : _vm.$route.params.brokerId
      }
    },"tag":"a"}},[_vm._v("Client Sources")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }